import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16 lg:pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1D3A] mb-8">
            Terms of Service
          </h1>
          <p className="text-sm text-slate-500 mb-8">Last updated: February 2026</p>

          <div className="prose prose-slate max-w-none">
            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                By accessing and using the Ultimate Infusions Private Limited website ("Website"), you accept and 
                agree to be bound by these Terms of Service. If you do not agree to these terms, please do not 
                use our Website.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">2. Description of Services</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Ultimate Infusions Private Limited provides frozen carbonated beverage (FCB) systems, post-mix 
                dispensing solutions, and related beverage services for businesses in India. Our Website provides 
                information about our products, services, and partnership opportunities.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">3. Use of Website</h2>
              <p className="text-slate-600 leading-relaxed mb-4">You agree to use this Website only for lawful purposes and in accordance with these Terms. You agree not to:</p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-4">
                <li>Use the Website in any way that violates applicable laws or regulations</li>
                <li>Attempt to gain unauthorized access to any part of the Website</li>
                <li>Use the Website to transmit harmful code or malware</li>
                <li>Interfere with the proper functioning of the Website</li>
                <li>Copy, reproduce, or distribute Website content without permission</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">4. Intellectual Property</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                All content on this Website, including text, graphics, logos, images, and software, is the property 
                of Ultimate Infusions Private Limited or its content suppliers and is protected by Indian and 
                international copyright laws. The Ultimate Infusions name, logo, and all related marks are 
                trademarks of Ultimate Infusions Private Limited.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">5. Business Partnerships</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                Information provided on this Website about partnership opportunities is for general informational 
                purposes only. Actual partnership terms, conditions, and agreements will be governed by separate 
                written contracts between Ultimate Infusions Private Limited and the partner entity.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">6. Product Information</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We make every effort to display accurate product information and specifications. However, we do not 
                warrant that product descriptions, images, pricing, or other content is accurate, complete, or 
                error-free. Product availability and specifications are subject to change without notice.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">7. Disclaimer of Warranties</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                This Website is provided "as is" without any warranties, express or implied. Ultimate Infusions 
                Private Limited does not warrant that the Website will be uninterrupted, error-free, or free of 
                viruses or other harmful components.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">8. Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                To the fullest extent permitted by law, Ultimate Infusions Private Limited shall not be liable for 
                any indirect, incidental, special, consequential, or punitive damages arising from your use of, or 
                inability to use, this Website or our services.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">9. Indemnification</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                You agree to indemnify and hold harmless Ultimate Infusions Private Limited, its officers, directors, 
                employees, and agents from any claims, damages, losses, or expenses arising from your use of the 
                Website or violation of these Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">10. Governing Law</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                These Terms shall be governed by and construed in accordance with the laws of India. Any disputes 
                arising under these Terms shall be subject to the exclusive jurisdiction of the courts in 
                Hyderabad, Telangana, India.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">11. Changes to Terms</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon 
                posting on this Website. Your continued use of the Website after changes constitutes acceptance of 
                the modified Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-xl font-bold text-[#0B1D3A] mb-4">12. Contact Information</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                For questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-slate-50 p-6 rounded-xl">
                <p className="text-slate-700 font-semibold">Ultimate Infusions Private Limited</p>
                <p className="text-slate-600 mt-2">S5, Br Apartments, Chinna Thokatta, Malani Society</p>
                <p className="text-slate-600">Hyderabad - 500011, Telangana, India</p>
                <p className="text-slate-600 mt-2">Email: info@ultimateinfusions.com</p>
                <p className="text-slate-600">Phone: +91 9110725125</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
